import * as types from 'constants/ActionTypes';

export const fetchTvaValues = () => ({
  type: types.FETCH_TVA_VALUES_REQUEST,
});

export const fetchTvaValuesFailure = error => ({
  type: types.FETCH_TVA_VALUES_FAILURE,
  error,
});

export const fetchTvaValuesSuccess = values => ({
  type: types.FETCH_TVA_VALUES_SUCCESS,
  values,
});
